<template>
  <div>
    <div class="container top-level-div">
      <div v-if="$store.getters.userID == user.id">
        <h2 ref="pageTitle">Welcome to {{ $store.getters.agencyHumanName }}<span v-if="user.first_name">, </span>{{ user.first_name }}</h2>
        <hr style="margin-bottom: 0;">
      </div>

      <!-- <div v-if="user.status == 'Hired' && editAccess" class="mt-3 mb-2"> -->
      <!-- <div v-if="editAccess" class="mt-3 mb-2"> -->
        <!-- <button class="mylisting-button dark-button" :class="{ 'selectedTab': tab == 'profile' }" @click="tab = 'profile'">My Profile</button> -->
        <!-- <button class="mylisting-button dark-button" :class="{ 'selectedTab': tab == 'jobs' }" @click="tab = 'jobs'">Available Jobs</button> -->
      <!-- </div> -->

      <div v-if="user.id && tab == 'profile'">
        <!-- {{ user }} -->
        <app-profile-view :user="user" @userUpdated="getUser()"></app-profile-view>
      </div>

      <div v-if="user.id && tab == 'jobs'" style="margin-top: -12.5vh;">
        <!-- {{ user }} -->
        <!-- <my-jobs :user="user" @userUpdated="getUser()"></my-jobs> -->
        <job-board></job-board>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  // import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import ProfileView from './profile/ProfileView'
  import MyJobs from './jobs/MyJobs'
  import JobBoard from '../jobBoard/JobBoard'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    props: ['userID'],
    data () {
      return {
        user: {},
        tab: 'profile',
      }
    },
    components: {
      appProfileView: ProfileView,
      MyJobs,
      JobBoard,
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
      editAccess() {
        if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
          return true
        } else {
          return false
        }
      },
    },
    created () {
      if (!this.userID) { // Don't want to scroll the page up if viewing the profile via the admin dashboard
        // Scroll the window up
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      }

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },2000)

      this.getUser()
    },
    mounted() {
      // document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      getUser() {
        var userID = null
        if (this.userID) {
          userID = this.userID
        }
        else if (this.$route.params.id) {
          userID = this.$route.params.id
        }
        else {
          userID = this.$store.getters.userID
        }
        // console.log(this.$store.getters.userID)

        // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
        axios.get('/api/people/?id='+userID.toString())
          .then(res => {
            // console.log(res)
            this.user = res.data[0]
          })
          .catch(error => console.log(error))
      },
      userUpdated() {
        this.getUser()
      }
    },
  }
</script>

<style>
  .selectedTab {
    background-color: var(--nannycogreen);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/candidates/Dashboard.vue